


























import Vue, { VNode } from "vue";
import { v4 as uuidv4 } from "uuid";

const FormControl = Vue.extend({
  props: {
    id: { type: String },
    label: { type: String },
    value: { type: String },
    type: { type: String, default: "text" },
    invalid: { type: Boolean },
    invalidFeedback: { type: String },
    validFeedback: { type: String },
    css: { type: Object },
    classes: { type: String },
    attrs: Object,
    dataset: Object,
    events: Object
  },

  render: function(createElement): VNode {
    return createElement(
      this.type === "textarea" || this.type === "select" ? this.type : "input",
      {
        class: [
          "form-control",
          this.invalid ? "is-invalid" : "is-valid",
          ...(this.classes
            ? this.classes
                .split(" ")
                .toString()
                .split(",")
            : [])
        ],
        style: {
          ...this.css
        },
        attrs: {
          id: this.id,
          value: this.value,
          type: this.type,
          ...this.attrs,
          ...this.dataset
        },
        on: {
          keyup: ($event: Event) => this.onKeyUp($event),
          change: ($event: Event) =>
            this.$emit("update", ($event.target as HTMLInputElement).value),
          ...this.events
        }
      },
      this.$slots.default
    );
  },

  methods: {
    onKeyUp: function(event: Event) {
      if (this.type === "textarea") {
        const textarea = this.$el as HTMLTextAreaElement;
        textarea.style.height = "auto";
        textarea.style.height = textarea.scrollHeight + "px";
      }
      const value = (event.target as HTMLInputElement).value;
      this.$emit("update", value);
    }
  }
});

export default Vue.extend({
  components: {
    FormControl
  },

  props: {
    model: { required: true, type: [String, Boolean, Number] },
    label: { type: String },
    type: { type: String, default: "text" },
    invalid: { type: Boolean },
    validFeedback: { type: String },
    invalidFeedback: { type: String },
    css: { type: Object },
    classes: { type: String },
    attrs: Object,
    data: Object,
    events: Object
  },

  computed: {
    id: () => uuidv4(),
    dataset: function() {
      const result: Record<string, string> = {};

      if (this.data) {
        for (const [key, value] of Object.entries(this.data)) {
          result[`data-${key}`] = value as string;
        }
      }
      return result;
    },
    isInvalid: function() {
      return (
        this.invalid ||
        (this.attrs?.required ? String(this.model).length < 2 : false)
      );
    }
  }
});
